import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const AuditLogPage = lazy(() => import('./pages/AuditLogPage'));

export const AuditLogRoutes: RouteObject = {
  path: 'audit-log',
  children: [
    { path: '', element: <AuditLogPage />, handle: { crumb: 'Audit Log' } },
  ],
};
